import { memo } from 'react'
import { useWireState } from '@forminator/react-wire'
import * as store from '@store'

import Dialog from '@components/shared/Dialogs/Dialog'
import cn from 'clsx'

const InviteNewMemberDialog = ({
    className,
    inviteMemberFirstName,
    loadingInviteMember,
    inviteMemberLastName,
    inviteMemberEmail,
    onInviteMemberClick,
    setInviteMemberFirstName,
    setInviteMemberLastName,
    setInviteMemberEmail,
}) => {
    
    const [open, setOpen] = useWireState(store.inviteNewOrgMemberDialogOpen)
    
    return (
        
        <Dialog
            className={cn('DocumentViewerModal relative', className)}
            panelClassName="max-w-screen-sm scale-y-95 modal-content"
            panelProps={{}}
            open={open}
            setOpen={setOpen}
            modal={false}
            title="Invite New Member"
            subtitle={null}
            positiveText="Invite via Email"
            positiveLoading={loadingInviteMember}
            positiveDisabled={loadingInviteMember}
            onPositiveClick={onInviteMemberClick}
            negativeText="Cancel"
            negativeDisabled={loadingInviteMember}
            onNegativeClick={() => setOpen(false)}>
            
            <div className="flex flex-col mt-2 form-group">
                
                <div className="flex justify-between gap-4">
                    <input
                        className="input input-bordered w-1/2"
                        type="text"
                        value={inviteMemberFirstName}
                        placeholder="John"
                        autoComplete="given-name"
                        disabled={loadingInviteMember}
                        onChange={e => setInviteMemberFirstName(e.target.value)}/>
                    <input
                        className="input input-bordered w-1/2"
                        type="text"
                        value={inviteMemberLastName}
                        placeholder="Doe"
                        autoComplete="family-name"
                        disabled={loadingInviteMember}
                        onChange={e => setInviteMemberLastName(e.target.value)}/>
                </div>
                
                <div className="flex justify-between gap-4 mt-2">
                    <input
                        className="input input-bordered w-full"
                        type="email"
                        value={inviteMemberEmail}
                        placeholder="someone@gmail.com"
                        autoComplete="email"
                        disabled={loadingInviteMember}
                        onChange={e => setInviteMemberEmail(e.target.value)}/>
                </div>
                
                <p className="mt-3 text-muted">
                    <i>
                        An account will be created for this member,
                        and they will receive an email with a link to
                        signup for Parse.
                    </i>
                </p>
                
                <p className="mt-3 text-muted">
                    <i>
                        If the member already has an account, they will
                        automatically be added to this organization.
                    </i>
                </p>
            
            </div>
        
        </Dialog>
        
    )
    
}

export default memo(InviteNewMemberDialog)
